import store from '../../store';
import actionTypes from '../../actions/actionTypes';

export function setCriteriaData(criteriaData) {
	store.dispatch({
		type: actionTypes.SET_CRITERIA_DATA,
		payload: criteriaData,
	});
}
